/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { UserStatus } from './UserStatus';
import {
    UserStatusFromJSON,
    UserStatusFromJSONTyped,
    UserStatusToJSON,
    UserStatusToJSONTyped,
} from './UserStatus';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    phone: string | null;
    /**
     * 
     */
    status: UserStatus;
    /**
     * 
     */
    type: UserType;
    /**
     * 
     */
    version: number;
    /**
     * 
     */
    createdTimestamp: Date;
    /**
     * 
     */
    updatedTimestamp: Date;
    /**
     * 
     */
    firstName: string | null;
    /**
     * 
     */
    lastName: string | null;
    /**
     * 
     */
    displayName: string | null;
}



/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if ((!('createdTimestamp' in (value as Record<string, any>)) && !('created_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdTimestamp'] === undefined && (value as Record<string, any>)['created_timestamp'] === undefined)) return false;
    if ((!('updatedTimestamp' in (value as Record<string, any>)) && !('updated_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedTimestamp'] === undefined && (value as Record<string, any>)['updated_timestamp'] === undefined)) return false;
    if ((!('firstName' in (value as Record<string, any>)) && !('first_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['firstName'] === undefined && (value as Record<string, any>)['first_name'] === undefined)) return false;
    if ((!('lastName' in (value as Record<string, any>)) && !('last_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastName'] === undefined && (value as Record<string, any>)['last_name'] === undefined)) return false;
    if ((!('displayName' in (value as Record<string, any>)) && !('display_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['displayName'] === undefined && (value as Record<string, any>)['display_name'] === undefined)) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'phone': json['phone'],
        'status': UserStatusFromJSON(json['status']),
        'type': UserTypeFromJSON(json['type']),
        'version': json['version'],
        'createdTimestamp': (json['created_timestamp'] == null ? json['created_timestamp'] : parseDateTime(json['created_timestamp'])),
        'updatedTimestamp': (json['updated_timestamp'] == null ? json['updated_timestamp'] : parseDateTime(json['updated_timestamp'])),
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'displayName': json['display_name'],
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'phone': value['phone'],
        'status': UserStatusToJSON(value['status']),
        'type': UserTypeToJSON(value['type']),
        'version': value['version'],
        'created_timestamp': value['createdTimestamp'] == null ? value['createdTimestamp'] : serializeDateTime(value['createdTimestamp']),
        'updated_timestamp': value['updatedTimestamp'] == null ? value['updatedTimestamp'] : serializeDateTime(value['updatedTimestamp']),
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'display_name': value['displayName'],
    };
}

